<script>
import StoreCard from '@maison/components/store/StoreCard';
import userPositionMixin from '@phoenix/mixins/userPositionMixin';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    StoreCard,
    PhxsgButton,
  },

  mixins: [userPositionMixin],

  props: {
    stores: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    enableNearMe: {
      type: Boolean,
      required: false,
      default: true,
    },
    boutiquesPageUrl: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    hasTitle() {
      return this.title && this.title.length > 0;
    },

    hasSubtitle() {
      return this.subtitle && this.subtitle.length > 0;
    },

    maxItems() {
      return this.stores ? this.stores.length : 0;
    },
  },
};
</script>

<template>
  <div class="boutique-push">
    <div class="boutique-push__header">
      <div v-if="hasTitle || hasSubtitle" class="headings boutique-push__headings">
        <!-- TODO: migration: replace by the heading component -->
        <h2 v-if="hasTitle">{{ title }}</h2>
        <!-- TODO: migration: replace by the heading component -->
        <h3 v-if="hasSubtitle" class="headings__subtitle">{{ subtitle }}</h3>
      </div>
      <phxsg-button
        v-if="enableNearMe"
        ref="positionBtn"
        variant="secondary"
        class="boutique-push__btn-geolocalization"
        :icon="{ start: { id: 'geoloc' } }"
        @click.prevent="useMyPosition"
      >
        {{ $t('Store.discover.nearest') }}
      </phxsg-button>
    </div>
    <div class="grid gap-lg grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      <store-card
        v-for="(store, index) in hasStoresNearMe ? nearStores : stores"
        :key="store.id ?? index"
        v-bind="store"
        :should-display-address="false"
      />
    </div>
    <div v-if="enableNearMe" class="grid grid-cols-1">
      <phxsg-button use="a" :href="boutiquesPageUrl" class="mt-base lg:mt-md mx-auto">
        {{ $t('Store.find.another') }}
      </phxsg-button>
    </div>
  </div>
</template>
